/** @jsxImportSource @emotion/react */
import { Route, Routes } from 'react-router-dom';
import {
  AlgorandProcessingOverview,
  AlgorandProcessingRequestDetails,
} from './components';

export const AlgorandProcessing = () => {
  return (
    <Routes>
      <Route path="/" element={<AlgorandProcessingOverview />} />
      <Route
        path="/:referenceId"
        element={<AlgorandProcessingRequestDetails />}
      />
    </Routes>
  );
};
